import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49419770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "faq" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "FAQ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Get to know more about how DogLink works", -1))
const _hoisted_4 = { class: "faq-questions" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", {
  class: "faq-answer",
  id: "answer_01"
}, "DogLink is a user-friendly microsite builder that allows you to create beautiful, mobile-optimized websites in minutes.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", {
  class: "faq-answer",
  id: "answer_02"
}, "Although DogLink can be used as link-in-bio, it is much more than that. A microsite is a website that’s dedicated to a single topic or idea, and it usually has a very specific purpose. You can use DogLink to build microsites for your brand, product, service or campaign.You are free to add as many as you like too. Showcase your videos on your page", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", {
  class: "faq-answer",
  id: "answer_03"
}, "During its beta stage, DogLink is free for anyone to use. Once the platform is officially launched, you’ll be able to use it for free or pay a monthly subscription fee for more advanced features.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", {
  class: "faq-answer",
  id: "answer_04"
}, "During its beta stage, DogLink is free for anyone to use. Once the platform is officially launched, you’ll be able to use it for free or pay a monthly subscription fee for more advanced features.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", {
  class: "faq-answer",
  id: "answer_05"
}, "Yes! DogLink is easy to use and doesn’t require any coding knowledge.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dd", {
  class: "faq-answer",
  id: "answer_06"
}, [
  /*#__PURE__*/_createTextVNode("You can sign up for an account on "),
  /*#__PURE__*/_createElementVNode("a", { href: "https://dashboard.doglink.net" }, "https://dashboard.doglink.net"),
  /*#__PURE__*/_createTextVNode(" and once you sign up, you’ll be taken to the main dashboard where you can start building your page.")
], -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqSection',
  setup(__props) {

const toggleAnswer = (answerId: string) => {
  document.getElementById(answerId).classList.toggle('hidden')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("dl", _hoisted_4, [
      _createElementVNode("dt", {
        class: "faq-question",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleAnswer('answer_01')))
      }, "What is DogLink?"),
      _hoisted_5,
      _createElementVNode("dt", {
        class: "faq-question",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleAnswer('answer_02')))
      }, "What is a microsite anyways? Is is the same as link-in-bio? "),
      _hoisted_6,
      _createElementVNode("dt", {
        class: "faq-question",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleAnswer('answer_03')))
      }, "How much does DogLink cost?"),
      _hoisted_7,
      _createElementVNode("dt", {
        class: "faq-question",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleAnswer('answer_04')))
      }, "How much does DogLink cost?"),
      _hoisted_8,
      _createElementVNode("dt", {
        class: "faq-question",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleAnswer('answer_05')))
      }, "Can I use DogLink if I don’t have any technical skills?"),
      _hoisted_9,
      _createElementVNode("dt", {
        class: "faq-question",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleAnswer('answer_06')))
      }, "How can I create my DogLink website?"),
      _hoisted_10
    ])
  ]))
}
}

})